var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBiBoxIcon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_91_3416)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.186 1.11291C8.06662 1.06507 7.93338 1.06507 7.814 1.11291L1.846 3.49991L4.25 4.46091L10.404 1.99991L8.186 1.11291ZM11.75 2.53891L5.596 4.99991L8 5.96091L14.154 3.49991L11.75 2.53891ZM15 4.23891L8.5 6.83891V14.7609L15 12.1609V4.23991V4.23891ZM7.5 14.7619V6.83791L1 4.23891V12.1619L7.5 14.7619ZM7.443 0.183911C7.80057 0.04091 8.19943 0.04091 8.557 0.183911L15.686 3.03591C15.7787 3.07306 15.8581 3.1371 15.9141 3.2198C15.9701 3.3025 16 3.40006 16 3.49991V12.1619C15.9999 12.3617 15.9399 12.5569 15.8278 12.7223C15.7157 12.8877 15.5566 13.0158 15.371 13.0899L8.186 15.9639C8.06662 16.0118 7.93338 16.0118 7.814 15.9639L0.63 13.0899C0.444251 13.0159 0.284942 12.888 0.172642 12.7226C0.0603417 12.5571 0.000206329 12.3618 0 12.1619L0 3.49991C2.32399e-05 3.40006 0.0299437 3.3025 0.085907 3.2198C0.14187 3.1371 0.221313 3.07306 0.314 3.03591L7.443 0.183911Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_91_3416"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBiBoxIcon);
export default __webpack_public_path__ + "static/media/bi_box-icon.8c51f8fc4bfd567ce993ea81fb1675af.svg";
export { ForwardRef as ReactComponent };